import { useState } from 'react';
import { UnderlineText } from 'components/RevxTypography';
import { Adjustment } from 'domains/workspaceDetailDomain';
import { JobItem } from 'domains/workspaceDomain';
import JobAdjustmentModal from '../../../../components/JobAdjustmentModal';
import { getFormatDate, ORDER_DATE_FORMAT } from 'components/RevxDate';

interface Props {
  jobData: JobItem;
  adjustment: Adjustment;
}

const CommonJobHistoryAdjustmentLink = (props: Props) => {
  const { jobData, adjustment } = props;
  const [modalVisible, setModalVisible] = useState<boolean>(false);

  const handleOpenModal = () => {
    setModalVisible(true);
  };

  return (
    <>
      <div style={{ padding: '5px 0' }}>
        <UnderlineText color="green" onClick={handleOpenModal}>
          {`Approved Job Adjustment - ${getFormatDate({
            dateStr: adjustment.adjustedAt,
            formatStr: ORDER_DATE_FORMAT,
            isLocalTime: true,
          })}`}
        </UnderlineText>
      </div>
      <JobAdjustmentModal
        visible={modalVisible}
        jobId={jobData.id}
        onCancel={() => setModalVisible(false)}
        readOnly={true}
        adjustmentId={adjustment.adjustmentId}
      />
    </>
  );
};

export default CommonJobHistoryAdjustmentLink;
